import Checkbox from '../ContactAddressCard/Checkbox'
import {
  toggleSelectContact,
  selectSelectedContacts,
  selectIsDeleteMode,
  selectContactFilterType,
} from '../../../../../../slices/contactAddressSlice'
import { FC } from 'react'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import useContactAddressCard from '../../../../../../hooks/useContactAddressCard'
import CardContent from './CardContent'
import CardProcessIcons from './ContactProcessIcons'
import ProfileImage from './ProfileImage'
import { useDispatch, useSelector } from 'react-redux'
import { selectRole } from '../../../../../../slices/authSlice'

type Props = {
  contactAddress: ContactAddressType
}

const ContactAddressCard: FC<Props> = (props) => {
  const { contactAddress } = props
  const dispatch = useDispatch()
  const { iconColor } = useContactAddressCard(contactAddress)
  
  const role = useSelector(selectRole);
  const isDeleteMode = useSelector(selectIsDeleteMode)
  const selectedContacts = useSelector(selectSelectedContacts)
  const isChecked = selectedContacts.includes(contactAddress.id)
  const contactFilterType = useSelector(selectContactFilterType)

  const canShowCheckbox =
    isDeleteMode &&
    (
      (role === 4 && (contactFilterType === 'personal' || contactFilterType === 'all')) ||
      (role !== 4 && contactFilterType === 'shared')
    )
  const isDisabledCheckbox = role === 4 && contactAddress.category === 'shared'

  const handleCheckboxChange = () => {
    if (!isDisabledCheckbox) {
      dispatch(toggleSelectContact(contactAddress.id))
    }
  }

  return (
    <div className="stack-small text-small">
      <div className="with-sidebar:big">
        <div className="with-sidebar:small d-flex align-items-center">
          {canShowCheckbox && (
            <Checkbox isChecked={isChecked} handleCheckboxChange={handleCheckboxChange} disabled={isDisabledCheckbox} />
          )}
          <ProfileImage iconColor={iconColor} contactAddress={contactAddress} />
          <CardContent contactAddress={contactAddress} />
        </div>
        <CardProcessIcons contactAddress={contactAddress} />
      </div>
      <hr />
    </div>

    //既存のコード
    // <div className="stack-small text-small">
    //   <div className="with-sidebar:big">
    //     <div className="with-sidebar:small">
    //       <ProfileImage iconColor={iconColor} contactAddress={contactAddress} />
    //       <CardContent contactAddress={contactAddress} />
    //     </div>

    //     <CardProcessIcons contactAddress={contactAddress} />
    //   </div>
    //   <hr />
    // </div>
  )
}

export default ContactAddressCard
